module.exports = __webpack_public_path__ + "img/res-icon-30.6617a5c7.png";